import { theme as antdTheme } from 'antd';

/**
 * 테마 → antd 토큰.
 *
 * antd 컴포넌트(버튼 · 표 · 달력 · 모달 · 입력창)는 CSS 변수를 읽지 않고
 * 자체 토큰으로 스타일을 만들기 때문에, theme.css 와 같은 색을 여기에도 넘겨야
 * 화면 전체가 한 벌로 보인다. 두 곳의 값이 어긋나면 antd 만 다른 색으로 남는다.
 */

const COMMON = {
  borderRadius: 6,
  borderRadiusLG: 6,
  borderRadiusSM: 4,
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
  wireframe: false,
};

const PALETTE = {
  white: {
    algorithm: antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: '#2563eb',
      colorInfo: '#0284c7',
      colorSuccess: '#059669',
      colorWarning: '#d97706',
      colorError: '#dc2626',

      colorBgLayout: '#f5f7fa',
      colorBgContainer: '#ffffff',
      colorBgElevated: '#ffffff',
      colorBorder: '#d3d9e2',
      colorBorderSecondary: '#e4e8ee',

      colorText: '#0f172a',
      colorTextSecondary: '#475569',
      colorTextTertiary: '#64748b',
      colorTextQuaternary: '#94a3b8',
    },
    components: {
      Table: { headerBg: '#f8fafc', headerColor: '#475569', rowHoverBg: '#f1f5f9' },
    },
  },

  black: {
    algorithm: antdTheme.darkAlgorithm,
    token: {
      colorPrimary: '#4f8dfd',
      colorInfo: '#38bdf8',
      colorSuccess: '#34d399',
      colorWarning: '#fbbf24',
      colorError: '#f87171',

      colorBgLayout: '#0b0d11',
      colorBgContainer: '#15181e',
      colorBgElevated: '#1b1f26',
      colorBorder: '#343a45',
      colorBorderSecondary: '#272c35',

      colorText: '#e7e9ee',
      colorTextSecondary: '#b9c0cc',
      colorTextTertiary: '#99a1af',
      colorTextQuaternary: '#6b7380',
    },
    components: {
      Table: { headerBg: '#1b1f26', headerColor: '#b9c0cc', rowHoverBg: '#222732' },
      // 어두운 배경 위에서는 팝업이 배경과 붙어 보여 한 단계 띄운다.
      Modal: { contentBg: '#15181e', headerBg: '#15181e' },
      Card: { colorBgContainer: '#15181e' },
    },
  },

  blue: {
    algorithm: antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: '#1d4ed8',
      colorInfo: '#0369a1',
      colorSuccess: '#047857',
      colorWarning: '#b45309',
      colorError: '#be123c',

      colorBgLayout: '#eef2f9',
      colorBgContainer: '#ffffff',
      colorBgElevated: '#ffffff',
      colorBorder: '#c5d2e6',
      colorBorderSecondary: '#dbe3f0',

      colorText: '#0d1c33',
      colorTextSecondary: '#3c4f6d',
      colorTextTertiary: '#56698a',
      colorTextQuaternary: '#8496b3',
    },
    components: {
      Table: { headerBg: '#f5f8fd', headerColor: '#3c4f6d', rowHoverBg: '#eaf0fa' },
    },
  },
};

/** ConfigProvider 에 넘길 theme 객체를 만든다. */
export const buildAntdTheme = (themeValue) => {
  const preset = PALETTE[themeValue] || PALETTE.white;

  return {
    algorithm: preset.algorithm,
    token: { ...COMMON, ...preset.token },
    components: preset.components,
  };
};

export default buildAntdTheme;
